module.exports = "<div class=\"row\"><div class=\"col\"><button class=\"btn btn-primary\" (click)=\"addRow()\">Add Row</button></div></div>\n<p></p>\n<hot-table [minSpareRows]=\"0\" [height]=\"600\" [manualColumnResize]=\"true\" [autoColumnSize]=\"true\" [startRows]=\"35\" [height]=\"600\" [rowHeaders]=\"rowHeaders\" [columns]=\"columns\" [data]=\"data\" hotId=\"FACS\">\n</hot-table>"


//////////////////
// WEBPACK FOOTER
// ./src/app/forecast-at-completion-cost-hour/forecast-at-completion-cost-hour.component.html
// module id = ./src/app/forecast-at-completion-cost-hour/forecast-at-completion-cost-hour.component.html
// module chunks = main